<template>
    <div class="page-order page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="24">
                    <h3 style="float: none;">店铺账单</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>账单管理</el-breadcrumb-item>
                            <el-breadcrumb-item>店铺账单</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <el-form-item style="margin-bottom: 0;" label="统计天数：">
                            <el-select v-model="form_search.lately_day" size="small" placeholder="请选择" @change="changeSelect">
                                <el-option
                                        v-for="item in init_data.time_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="账单时间：">
                            <el-date-picker
                                    size="small"
                                    clearable
                                    v-model="create_range"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
                            <el-table-column prop="desk_name" align="center" label="店铺名称" min-width="200">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.desk_name"></my-textEllipsis>
                                </template>
                            </el-table-column>
                            <el-table-column prop="desk_number" align="center" label="店铺编号" min-width="160">
                            </el-table-column>
                            <el-table-column prop="product_count" align="center" label="产品总数" min-width="120">
                            </el-table-column>
                            <el-table-column prop="paid_amount" align="center" label="订单总价" min-width="160">
                            </el-table-column>
                            <el-table-column prop="operating" align="right" label="操作" min-width="80" fixed="right">
                                <template slot-scope="scope">
                                    <el-button class="option-btn btn-bd-m" type="primary" size="mini" @click="goodsDetail(scope.row.desk_number)">明细</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                create_range:'',
                init_data:{
                    time_list:[{id:-1,name:'不限'},{id:7,name:'近7天'},{id:30,name:'近1个月'},{id:90,name:'近3个月'},{id:180,name:'近半年'}]
                },
                form_search:{
                    lately_day:-1,
                    start_date:'',
                    end_date:''
                },
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 10,
                        total: 130
                    }
                }
            }
        },
        created() {
            document.title = '店铺账单';
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            changeSelect(val){
                this.create_range = '';
                this.form_search.start_date = '';
                this.form_search.end_date = '';
            },
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                var status_list = [{id:-1, name: '全部'}];
                this.$client.get('/adminapi/statis/deskjoinorderdata', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            goodsDetail(desk_number){
                var data = {
                    desk_number:desk_number,
                    lately_day:this.form_search.lately_day,
                    start_date:this.form_search.start_date,
                    end_date:this.form_search.end_date
                };
                this.$util.goTo('/bill/companydetail',{query:data})
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            },
            create_range(newVal){
                //console.log(newVal);
                if(newVal){
                    this.form_search.lately_day = -1;
                }
                if(newVal == null){
                    this.form_search.start_date = '';
                    this.form_search.end_date = '';
                }else{
                    this.form_search.start_date = newVal[0];
                    this.form_search.end_date = newVal[1];
                }
            }
        }
    }
</script>
<style>

</style>
<style scoped>

</style>